import React, { memo } from 'react';
import { CalendarIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12 px-6" data-id="element-45">
      <div className="max-w-7xl mx-auto" data-id="element-46">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-47">
          {/* Logo & Description */}
          <div className="md:col-span-2" data-id="element-48">
            <div className="flex items-center gap-2 mb-4" data-id="element-49">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-400 to-orange-600 rounded-xl flex items-center justify-center" data-id="element-50">
                <CalendarIcon className="w-6 h-6 text-white" data-id="element-51" />
              </div>
              <span className="text-xl font-bold" data-id="element-52">Famday</span>
            </div>
            <p className="text-gray-400 max-w-md" data-id="element-53">
              The all-in-one family organization app. Keep everyone connected
              with shared calendars, to-dos, and memories.
            </p>
          </div>

          {/* Product Links */}
          <div data-id="element-54">
            <h3 className="font-semibold mb-4" data-id="element-55">Product</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-56">
              <li data-id="element-57">
                <a href="#features" className="hover:text-white transition-colors" data-id="element-58">
                  Features
                </a>
              </li>
              <li data-id="element-59">
                <a href="#download" className="hover:text-white transition-colors" data-id="element-60">
                  Download
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="hover:text-white transition-colors" data-id="element-62">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-63">
            <h3 className="font-semibold mb-4" data-id="element-64">Legal</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-65">
              <li data-id="element-66">
                <a href="https://go.pixo.co/famcal-privacy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-67">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-68">
                <a href="https://go.pixo.co/famcal-terms" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-69">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-70">
                <a href="mailto:support@pixo.co" className="hover:text-white transition-colors" data-id="element-71">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400" data-id="element-72">
          <p data-id="element-73">&copy; 2026 Famday. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}